import { TOrganizationFAQ } from '@/services/api/organization-api';
import { Service } from '@/services/api/services-api';
import { TUserData } from '@/services/api/user-api';
import React from 'react';
import NBLandingByDivisions from './NBLandingByDivisions';
import NBLandingByRange from './NBLandingByRange';

interface Props {
  service: Service;
  organization: TOrganizationFAQ;
  user: TUserData | undefined;
}
const NBLandingContainer: React.FC<Props> = (props) => {
  const { service, organization, user } = props;
  const hasGroupDivisions = service.rangeDivisions?.length > 0;
  return (
    <div className="mt-8 md:container">
      {hasGroupDivisions ? (
        <NBLandingByRange service={service} organization={organization} />
      ) : (
        <NBLandingByDivisions service={service} organization={organization} />
      )}
    </div>
  );
};

export default NBLandingContainer;
